import { locales } from '../../router/routerAliases';

function getAliasByLocale(locale: string, match: string) {
  return (locales[locale] && locales[locale][match]) || match;
}

export default getAliasByLocale;
